import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Offsets the shimmer sweep, so a stack of skeletons resolves as a wave. */
  delayMs?: number;
}

/**
 * Placeholder block with a shimmer sweep. Size it with utility classes so the
 * skeleton matches the shape of whatever it stands in for.
 */
export function Skeleton({ className, delayMs, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('relative overflow-hidden rounded-md bg-muted', className)}
      aria-hidden="true"
      {...props}
    >
      <div
        className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-foreground/[0.07] to-transparent motion-reduce:hidden"
        style={delayMs ? { animationDelay: `${delayMs}ms` } : undefined}
      />
    </div>
  );
}
